import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getContactTypeList, selectCurrentUser, selectUserData } from '~/features/dashboard/store/selectors';
import { useRouteMatch } from 'react-router-dom';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { Controller, useForm } from 'react-hook-form';
import { AddContactFormNames, NewUser } from '~/store/user/models';
import { Button, Grid, Switch, TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import classNames from 'classnames';
import css from '~/features/dashboard/components/new-edit-contact/styles.module.scss';
import Avatar from '@material-ui/core/Avatar';
import { DatePickerController } from '~/features/dashboard/components/date-picker-controller';
import PhoneInput from 'react-phone-input-2';
import { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete/Autocomplete';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import { axiosInstance } from '~/api/config/axios.config';
import { createContact, getContactTypes } from '~/features/dashboard/store/actions.thunks';
import _ from 'underscore';

export const EditContactListDrawer: React.FC<{ title: string; role?: number; closeDrawer: () => void }> = ({ title = 'Legal Entity', role, closeDrawer }) => {
    const user = useSelector(selectUserData);
    const match = useRouteMatch<{ creatorId: string }>();
    const newDealState = useSelector(selectCurrentUser);
    const [kontactCode, setKontactCode] = useState('');

    const contactId = newDealState?.contactId ? newDealState?.contactId : 0;
    const contactCode = newDealState?.contactCode ? newDealState?.contactCode : '';
    const kontactId = newDealState?.kontactId ? newDealState?.kontactId : 0;
    const creatorCode = newDealState?.creatorCode ? newDealState?.creatorCode : '';
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);

    const [isPhone2, setIsPhone2] = useState(false);
    const [isPhone3, setIsPhone3] = useState(false);
    const [isPhone4, setIsPhone4] = useState(false);
    const [countryCode, setCountryCode] = useState('');
    const dispatch = useThunkDispatch();
    const [imageFile, setImageFile] = useState<any>();
    const initialTelephoneType = { Id: 1, TelephoneType: 'Mobile' };
    const [telephoneType, setTelephoneType] = useState<{ Id: any; TelephoneType: any }[]>([initialTelephoneType]);

    const [fillAddressCreator, setFillAddressCreator] = useState<boolean>(false);

    const { handleSubmit, control, register, setValue, errors, getValues } = useForm<NewUser>({
        defaultValues: {
            FIRST_NAME: newDealState?.firstName,
            COMPANY_NAME: newDealState?.companyName || newDealState?.creatorCompanyName,
            LAST_NAME: newDealState?.lastName,
            PHONE: newDealState?.phone,
            PHONE2: newDealState?.phone2,
            PHONE3: newDealState?.phone3,
            PHONE4: newDealState?.phone4,
            PHONEType: newDealState?.phoneType,
            PHONE2Type: newDealState?.phoneType2,
            PHONE3Type: newDealState?.phoneType3,
            PHONE4Type: newDealState?.phoneType4,
            konAddId: newDealState?.konAddId,
            EMAIL: newDealState?.email,
            DESCRIPTION: newDealState?.description,
            addressLine1: newDealState?.addressLine1 || '',
            addressLine2: newDealState?.addressLine2 || '',
            addressLine3: newDealState?.addressLine3 || '',
            addressLine4: newDealState?.addressLine4 || '',
            ROLE: newDealState?.contactTypeDesc,
            startDate: newDealState?.startDate,
            endDate: newDealState?.endDate,
            contactId: newDealState?.contactId,
            contactCode: newDealState?.contactCode,
            CREATOR_ROLE: newDealState?.role,
            CREATOR_FULL_NAME: newDealState?.fullName,
            country: newDealState?.addressLine1 || '',
            locality: newDealState?.cityName || '',
            postal_code: newDealState?.zipCode || '',
            route: newDealState?.route || '',
        },
    });

    let dealTypes = useSelector(getContactTypeList);
    let deal: any = [];
    if (dealTypes.length) {
        deal = _.pluck(dealTypes, 'name');
    }

    useEffect(() => {
        user && setKontactCode(user.contactCode);
    }, [user]);

    const onSubmit = useCallback(
        (data: any) => {
            dispatch(createContact({ ...data, creatorId, contactId, contactCode, kontactId, creatorCode, kontactCode })).then(() => closeDrawer());
        },
        // eslint-disable-next-line
        [dispatch]
    );

    useEffect(() => {
        if (fillAddressCreator) {
            setValue('addressLine1', user?.addressLine1 || '');
            setValue('addressLine2', user?.addressLine2 || '');
            setValue('addressLine3', user?.addressLine3 || '');
            setValue('addressLine4', user?.addressLine4 || '');
            setValue('postal_code', user?.zipCode || '');
        } else {
            setValue('addressLine1', newDealState?.addressLine1 || '');
            setValue('addressLine2', newDealState?.addressLine2 || '');
            setValue('addressLine3', newDealState?.addressLine3 || '');
            setValue('addressLine4', newDealState?.addressLine4 || '');
            setValue('postal_code', newDealState?.zipCode || '');
        }
        // eslint-disable-next-line
    }, [fillAddressCreator]);

    useEffect(() => {
        setValue(
            'PHONEType',
            telephoneType.find(item => item.Id === user?.phoneType)
        );
        setValue(
            'PHONE2Type',
            telephoneType.find(item => item.Id === user?.phoneType2)
        );
        setValue(
            'PHONE3Type',
            telephoneType.find(item => item.Id === user?.phoneType3)
        );
        setValue(
            'PHONE4Type',
            telephoneType.find(item => item.Id === user?.phoneType4)
        );
        // eslint-disable-next-line
    }, [telephoneType]);
    useEffect(() => {
        axiosInstance.get('Catalogue/projectReference/TelephoneType/list').then(data => {
            setTelephoneType(data.data);
        });
        newDealState?.addressLine1 === user?.addressLine1 &&
        newDealState?.addressLine2 === user?.addressLine2 &&
        newDealState?.addressLine3 === user?.addressLine3 &&
        newDealState?.addressLine4 === user?.addressLine4 &&
        newDealState?.zipCode === user?.zipCode &&
        setFillAddressCreator(true);

        newDealState?.phone2 && setIsPhone2(true);
        newDealState?.phone3 && setIsPhone3(true);
        newDealState?.phone4 && setIsPhone4(true);
        // eslint-disable-next-line
    }, []);
    const switchPhone = () => {
        setIsPhone2(true);
        isPhone2 && setIsPhone3(true);
        isPhone2 && isPhone3 && setIsPhone4(true);
    };

    useEffect(() => {
        dispatch(getContactTypes());
        // eslint-disable-next-line
    }, [dispatch]);

    // Google api places autocomplete
    let autocomplete: google.maps.places.Autocomplete;

    const componentForm: any = {
        route: 'long_name',
        locality: 'long_name',
        country: 'long_name',
        postal_code: 'short_name',
        postal_code_suffix: 'short_name',
        postal_town: 'long_name',
        sublocality_level_1: 'long_name',
        neighborhood: 'long_name',
        street_number: 'long_name',
        administrative_area_level_1: 'long_name',
        administrative_area_level_2: 'long_name',
        administrative_area_level_3: 'long_name',
        premise: 'long_name',
        sublocality_level_2: 'long_name',
    };
    function initAutocomplete() {
        // Create the autocomplete object, restricting the search predictions to
        // geographical location types.
        autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('autocomplete') as HTMLInputElement, { types: ['geocode'] });
        autocomplete.setFields(['address_component']);

        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        autocomplete.addListener('place_changed', fillInAddress);
    }
    initAutocomplete();
    function fillInAddress() {
        // Get the place details from the autocomplete object.
        const place = autocomplete.getPlace();
        for (const component in componentForm) {
            if (component === 'route') {
                setValue('addressLine2', '');
            }
            if (component === 'locality') {
                setValue('addressLine1', '');
            }
            if (component === 'country') {
                setValue('addressLine3', '');
            }
            if (component === 'postal_code') {
                setValue('postal_code', '');
            }
            if (component === 'sublocality_level_1' || component === 'neighborhood') {
                setValue('addressLine4', '');
            }
        }
        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.
        let component: any;

        let postal_town: any;
        let locality: any;
        let administrative_area_level_1: any;
        let administrative_area_level_2: any;
        let country: any;

        for (component of place.address_components as google.maps.GeocoderAddressComponent[]) {
            // @ts-ignore remove once typings fixed
            const addressType = component.types[0];
            if (componentForm[addressType]) {
                const val = component[componentForm[addressType]];
                if (addressType === 'street_number') {
                    setValue('addressLine1', val);
                }
                if (addressType === 'sublocality_level_1') {
                    let valueMerge = getValues('addressLine1');
                    let finalVal = valueMerge !== '' ? valueMerge + ' , ' + val : val;
                    setValue('addressLine1', finalVal);
                }
                if (addressType === 'sublocality_level_2') {
                    let valueMerge = getValues('addressLine1');
                    let finalVal = valueMerge !== '' ? valueMerge + ' , ' + val : val;
                    setValue('addressLine1', finalVal);
                }
                if (addressType === 'route') {
                    let streetmerge = getValues('addressLine1');
                    let finalVal = streetmerge !== '' ? streetmerge + ' , ' + val : val;
                    setValue('addressLine1', finalVal);
                }
                if (addressType === 'postal_town') {
                    postal_town = val;
                }
                if (addressType === 'administrative_area_level_1') {
                    administrative_area_level_1 = val;
                }
                if (addressType === 'locality') {
                    locality = val;
                }
                if (addressType === 'administrative_area_level_3') {
                    let merge = getValues('addressLine2');
                    let finalVal = merge !== '' ? merge + ' , ' + val : val;
                    setValue('addressLine2', finalVal);
                }
                if (addressType === 'administrative_area_level_2') {
                    administrative_area_level_2 = val;
                }
                if (addressType === 'neighborhood') {
                    let streetmerge = getValues('addressLine1');
                    let finalVal = streetmerge !== '' ? streetmerge + ' , ' + val : val;
                    setValue('addressLine1', finalVal);
                }
                if (addressType === 'premise') {
                    let streetmerge = getValues('addressLine1');
                    let finalVal = streetmerge !== '' ? streetmerge + ' , ' + val : val;
                    setValue('addressLine1', finalVal);
                }
                if (addressType === 'postal_code') {
                    let merge = getValues('postal_code');
                    let finalVal = merge !== '' ? merge + ' - ' + val : val;
                    setValue('postal_code', finalVal);
                }
                if (addressType === 'postal_code_suffix') {
                    let merge = getValues('postal_code');
                    let finalVal = merge !== '' ? merge + ' - ' + val : val;
                    setValue('postal_code', finalVal);
                }
                if (addressType === 'postal_code_prefix') {
                    let merge = getValues('postal_code');
                    let finalVal = merge !== '' ? val + ' ' + merge : val;
                    setValue('postal_code', finalVal);
                }
                if (addressType === 'country') {
                    country = component.long_name;
                    country === 'Sweden' && setValue('addressLine2', administrative_area_level_1);
                    setValue('addressLine4', component.long_name);
                    setCountryCode(component.short_name);
                }
                setValue('addressLine3', postal_town ? postal_town : locality);
                setValue('addressLine2', postal_town ? administrative_area_level_2 : administrative_area_level_1);
            }
        }
    }
    deal = deal
        .filter((item: any) => item !== 'My Legal Entity')
        // .filter((item: any) => item !== 'My Deal Contact')
        .filter((item: any) => item !== 'Creator');

    return (
        <div className={css.module}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <input type="hidden" ref={register} name={'contactCode'} />
                <input type="hidden" ref={register} name={'contactId'} />
                <input type="hidden" ref={register} name={AddContactFormNames.KONAddId} />
                {(role || role === 0) && <input type="hidden" ref={register} name={AddContactFormNames.ROLE} value={role} />}
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography style={{ width: '40%' }} className={classNames(css.bold, css.title)}>
                            {!!newDealState ? `Edit ${title} Data` : `New ${title}`}
                        </Typography>
                    </Grid>
                    {!role && role !== 0 && (
                        <Grid item xs={12}>
                            <Controller
                                render={props => (
                                    <Autocomplete
                                        {...props}
                                        options={deal}
                                        className={css.input}
                                        fullWidth
                                        renderInput={(p: AutocompleteRenderInputParams) => (
                                            <div>
                                                <Typography className={classNames(css.bold, css.infoTitle)}>Role</Typography>
                                                <TextField
                                                    {...p}
                                                    className={css.textInput}
                                                    variant="filled"
                                                    error={!!errors.ROLE}
                                                    helperText={errors.ROLE ? errors.ROLE.message : ''}
                                                />
                                            </div>
                                        )}
                                        onChange={(_, data) => props.onChange(data)}
                                    />
                                )}
                                name={AddContactFormNames.ROLE}
                                control={control}
                            />
                        </Grid>
                    )}
                    <Grid item xs={10}>
                        <Typography className={classNames(css.bold, css.infoTitle)}>Company Name</Typography>
                        <TextField
                            className={css.textInput}
                            inputRef={register}
                            fullWidth
                            defaultValue={user?.companyName || ''}
                            name={AddContactFormNames.COMPANY_NAME}
                        />
                    </Grid>
                    <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div>
                            {imageFile ? (
                                <Avatar className={css.avatarCustom} src={imageFile} />
                            ) : newDealState?.image && newDealState?.image !== process.env.REACT_APP_ASSET ? (
                                <Avatar className={css.avatarCustom} alt={newDealState?.fullName} src={newDealState?.image} />
                            ) : (
                                <Avatar className={css.avatarCustom} src={newDealState?.image} />
                            )}
                            <input
                                type="file"
                                accept=".jpg, .jpeg, .png"
                                ref={register}
                                name={AddContactFormNames.IMAGE}
                                id="file"
                                className={css.inputFile}
                                onChange={e => {
                                    let files = e.target.files || '';
                                    setImageFile(URL.createObjectURL(files[0]));
                                }}
                            />
                            <label htmlFor="file">Add Photo</label>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography className={classNames(css.bold, css.infoTitle)}>First Name</Typography>
                        <TextField className={css.textInput} inputRef={register} fullWidth name={AddContactFormNames.FIRST_NAME} />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography className={classNames(css.bold, css.infoTitle)}>Last Name</Typography>
                        <TextField className={css.textInput} inputRef={register} fullWidth name={AddContactFormNames.LAST_NAME} />
                    </Grid>
                    {role !== 0 && (
                        <Grid className={css.customDatePicker} item xs={6}>
                            <DatePickerController name={AddContactFormNames.startDate} control={control} label="Start Date" row />
                        </Grid>
                    )}
                    {role !== 0 && (
                        <Grid className={css.customDatePicker} item xs={6}>
                            <DatePickerController name={AddContactFormNames.endDate} control={control} label="End Date" row />
                        </Grid>
                    )}
                    <Grid item xs={role === 8 ? 8 : 12}>
                        <Typography className={classNames(css.bold, css.infoTitle)}>Search on Google for Address</Typography>
                        <TextField
                            className={css.textInput}
                            inputRef={register}
                            multiline
                            rows={1}
                            fullWidth
                            id="autocomplete"
                            // placeholder={'Search For Address'}
                            rowsMax={20}
                        />
                    </Grid>
                    {role === 8 && (
                        <Grid item xs={4}>
                            <Typography className={classNames(css.bold, css.infoTitle)}>Same as Creator’s?</Typography>
                            <div
                                className="inputcustom-outer switch-custom-outer"
                                style={{ display: 'flex', alignItems: 'center', marginTop: '1rem', marginLeft: '26px' }}
                            >
                                <span>No</span>
                                <Switch
                                    id="e-book-switch1"
                                    type="checkbox"
                                    name="isFillAddress"
                                    onChange={e => setFillAddressCreator(e.target.checked || false)}
                                    value={fillAddressCreator}
                                    checked={fillAddressCreator}
                                />
                                <span> Yes</span>
                            </div>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Typography className={classNames(css.bold, css.infoTitle)}>Street</Typography>
                        <Controller
                            render={props => (
                                <TextField
                                    className={css.textInput}
                                    // id="route"
                                    id="addressLine1"
                                    fullWidth
                                    value={props.value}
                                    onChange={e => props.onChange(e.target.value)}
                                />
                            )}
                            // name={AddContactFormNames.addressLine2}
                            name={AddContactFormNames.addressLine1}
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Controller
                            render={props => (
                                <div>
                                    <Typography className={classNames(css.bold, css.infoTitle)}>City</Typography>
                                    <TextField
                                        className={css.textInput}
                                        id="locality"
                                        fullWidth
                                        value={props.value}
                                        onChange={e => props.onChange(e.target.value)}
                                    />
                                </div>
                            )}
                            name={AddContactFormNames.addressLine3}
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Controller
                            render={props => (
                                <div>
                                    <Typography className={classNames(css.bold, css.infoTitle)}>State/County</Typography>
                                    <TextField
                                        className={css.textInput}
                                        fullWidth
                                        value={props.value}
                                        defaultValue={props.value}
                                        // placeholder="Write"
                                        // id="addressLine1"
                                        id="route"
                                        onChange={e => props.onChange(e.target.value)}
                                    />
                                </div>
                            )}
                            // name={AddContactFormNames.addressLine1}
                            name={AddContactFormNames.addressLine2}
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Controller
                            render={props => (
                                <div>
                                    <Typography className={classNames(css.bold, css.infoTitle)}>Country</Typography>
                                    <TextField
                                        className={css.textInput}
                                        fullWidth
                                        value={props.value}
                                        defaultValue={props.value}
                                        // placeholder="Write"
                                        id="addressLine4"
                                        onChange={e => props.onChange(e.target.value)}
                                    />
                                </div>
                            )}
                            name={AddContactFormNames.addressLine4}
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            render={props => (
                                <div>
                                    <Typography className={classNames(css.bold, css.infoTitle)}>Zip Code</Typography>
                                    <TextField
                                        className={css.textInput}
                                        value={props.value}
                                        defaultValue={props.value}
                                        fullWidth
                                        type="text"
                                        id="postal_code"
                                        // placeholder={'Write'}
                                        onChange={e => props.onChange(e.target.value)}
                                    />
                                </div>
                            )}
                            name={AddContactFormNames.ZIP_CODE}
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography className={classNames(css.bold, css.infoTitle)}>Email</Typography>
                        <TextField
                            className={css.textInput}
                            inputRef={register}
                            fullWidth
                            // placeholder={'Write'}
                            type={'email'}
                            name={AddContactFormNames.EMAIL}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container style={{ position: 'relative' }}>
                            <Grid item xs={8}>
                                <Typography className={classNames(css.bold, css.infoTitle)}>Phone</Typography>
                                <Controller
                                    render={props => (
                                        <PhoneInput
                                            country={countryCode.toLowerCase() || 'us'}
                                            value={props.value}
                                            containerStyle={{ paddingRight: '20px' }}
                                            specialLabel={''}
                                            inputStyle={{
                                                width: '100%',
                                                border: '1px solid #a2a2a2',
                                                borderRadius: '8px',
                                                backgroundColor: '#efefef',
                                            }}
                                            onChange={(e: any) => {
                                                props.onChange(e);
                                            }}
                                        />
                                    )}
                                    name={AddContactFormNames.PHONE}
                                    control={control}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classNames(css.bold, css.infoTitle)}>Type</Typography>
                                <Controller
                                    render={props => (
                                        <Autocomplete
                                            {...props}
                                            options={telephoneType}
                                            getOptionLabel={option => option.TelephoneType}
                                            renderOption={option => <React.Fragment>{option.TelephoneType}</React.Fragment>}
                                            className={css.textInputType}
                                            fullWidth
                                            renderInput={(p: AutocompleteRenderInputParams) => <TextField {...p} variant="filled" value={props.value} />}
                                            onChange={(_, data) => {
                                                props.onChange(data);
                                            }}
                                        />
                                    )}
                                    name={AddContactFormNames.PHONEType}
                                    control={control}
                                />
                            </Grid>
                            {(!isPhone2 || !isPhone3 || !isPhone4) && <AddCircleOutlineIcon className={css.addButton} onClick={switchPhone} />}
                        </Grid>
                    </Grid>
                    {isPhone2 && (
                        <Grid item xs={12}>
                            <Grid container style={{ position: 'relative' }}>
                                <Grid item xs={8}>
                                    <Controller
                                        render={props => (
                                            <PhoneInput
                                                country={countryCode.toLowerCase() || 'us'}
                                                specialLabel={''}
                                                value={props.value}
                                                // value={cellPhone}
                                                inputClass="newclass"
                                                containerStyle={{ paddingRight: '20px' }}
                                                inputStyle={{
                                                    width: '100%',
                                                    border: '1px solid #a2a2a2',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#efefef',
                                                    minHeight: '40px',
                                                }}
                                                onChange={(e: any) => {
                                                    props.onChange(e);
                                                }}
                                            />
                                        )}
                                        name={AddContactFormNames.PHONE2}
                                        control={control}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Controller
                                        render={props => (
                                            <Autocomplete
                                                {...props}
                                                options={telephoneType}
                                                getOptionLabel={option => option.TelephoneType}
                                                renderOption={option => <React.Fragment>{option.TelephoneType}</React.Fragment>}
                                                className={css.textInputType}
                                                fullWidth
                                                renderInput={(p: AutocompleteRenderInputParams) => <TextField {...p} variant="filled" value={props.value} />}
                                                onChange={(_, data) => {
                                                    props.onChange(data);
                                                }}
                                            />
                                        )}
                                        name={AddContactFormNames.PHONEType2}
                                        control={control}
                                    />
                                </Grid>
                                <CloseIcon
                                    className={css.deletePhone}
                                    onClick={() => {
                                        setIsPhone2(false);
                                        setValue(AddContactFormNames.PHONE2, '');
                                    }}
                                />
                            </Grid>
                        </Grid>
                    )}
                    {isPhone3 && (
                        <Grid item xs={12}>
                            <Grid container style={{ position: 'relative' }}>
                                <Grid item xs={8}>
                                    <Controller
                                        render={props => (
                                            <PhoneInput
                                                country={countryCode.toLowerCase() || 'us'}
                                                specialLabel={''}
                                                value={props.value}
                                                inputClass="newclass"
                                                containerStyle={{ paddingRight: '20px' }}
                                                inputStyle={{
                                                    width: '100%',
                                                    border: '1px solid #a2a2a2',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#efefef',
                                                }}
                                                onChange={(e: any) => {
                                                    props.onChange(e);
                                                }}
                                            />
                                        )}
                                        name={AddContactFormNames.PHONE3}
                                        control={control}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Controller
                                        render={props => (
                                            <Autocomplete
                                                {...props}
                                                options={telephoneType}
                                                getOptionLabel={option => option.TelephoneType}
                                                renderOption={option => <React.Fragment>{option.TelephoneType}</React.Fragment>}
                                                className={css.textInputType}
                                                fullWidth
                                                renderInput={(p: AutocompleteRenderInputParams) => <TextField {...p} variant="filled" value={props.value} />}
                                                onChange={(_, data) => {
                                                    props.onChange(data);
                                                }}
                                            />
                                        )}
                                        name={AddContactFormNames.PHONEType3}
                                        control={control}
                                    />
                                </Grid>
                                <CloseIcon
                                    className={css.deletePhone}
                                    onClick={() => {
                                        setIsPhone4(false);
                                        setValue(AddContactFormNames.PHONE3, '');
                                    }}
                                />
                            </Grid>
                        </Grid>
                    )}
                    {isPhone4 && (
                        <Grid item xs={12}>
                            <Grid container style={{ position: 'relative' }}>
                                <Grid item xs={8}>
                                    <Controller
                                        render={props => (
                                            <PhoneInput
                                                country={countryCode.toLowerCase() || 'us'}
                                                specialLabel={''}
                                                value={props.value}
                                                inputClass="newclass"
                                                containerStyle={{ paddingRight: '20px' }}
                                                inputStyle={{
                                                    width: '100%',
                                                    border: '1px solid #a2a2a2',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#efefef',
                                                }}
                                                onChange={(e: any) => {
                                                    props.onChange(e);
                                                }}
                                            />
                                        )}
                                        name={AddContactFormNames.PHONE4}
                                        control={control}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Controller
                                        render={props => (
                                            <Autocomplete
                                                {...props}
                                                options={telephoneType}
                                                getOptionLabel={option => option.TelephoneType}
                                                renderOption={option => <React.Fragment>{option.TelephoneType}</React.Fragment>}
                                                className={css.textInputType}
                                                fullWidth
                                                renderInput={(p: AutocompleteRenderInputParams) => <TextField {...p} variant="filled" value={props.value} />}
                                                onChange={(_, data) => {
                                                    props.onChange(data);
                                                }}
                                            />
                                        )}
                                        name={AddContactFormNames.PHONEType4}
                                        control={control}
                                    />
                                </Grid>
                                <CloseIcon
                                    className={css.deletePhone}
                                    onClick={() => {
                                        setIsPhone4(false);
                                        setValue(AddContactFormNames.PHONE4, '');
                                    }}
                                />
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <div className={css.customGrid}>
                            <Typography className={classNames(css.bold, css.infoTitle)}>Description</Typography>
                            <TextField className={css.textInput} inputRef={register} multiline rows={5} fullWidth name={AddContactFormNames.DESCRIPTION} />
                        </div>
                    </Grid>
                </Grid>
                <Button className={css.submitBtn} type={'submit'}>
                    Submit
                </Button>
            </form>
        </div>
    );
};
